import { autoinject, transient } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../configuration/event-messages.constants";
import { RSInspectionCompanyResponseModel } from "../../../models/rightship-inspections/rightship-inspections.models";
import { RightShipInspectionsService } from "../../../services/rightship-inspections/rightship-inspections.service";
import { Guid } from "../../../utilities/guid";

//Load styles
require("../../../styles/rightship-inspection-company-response-client/core-rightship-inspection-company-response-client.scss");

@autoinject()
@transient()
export class LayoutRsInspectionCompanyResponse {

    public showDatePicker: boolean = false;
    public errorMessage: string;
    public isSuccessful: boolean = true;
    public isSubmit: boolean = false;
    public response: boolean = false;
    public guid: Guid = null;
    public model: RSInspectionCompanyResponseModel;
    public isAleardySubmitted: boolean;
    public furtherInformation: string;
    public rejectedReason: RejectReasonModel;

    public rejectReasons: RejectReasonModel[] = [
        { id: 1, value: "No available inspector", displayText: "No available inspector", hasFurtherInfo: false},
        { id: 2, value: "Insufficient notice", displayText: "Insufficient notice", hasFurtherInfo: false},
        { id: 3, value: "Travel restriction", displayText: "Travel restriction (please provide further information below)", hasFurtherInfo: true},
        { id: 4, value: "Port restriction", displayText: "Port restriction (please provide further information below)", hasFurtherInfo: true},
        { id: 5, value: "Other", displayText: "Other (please provide further information below)", hasFurtherInfo: true}
    ];

    constructor(private eventAggregator: EventAggregator, private rightshipInsepctionsService: RightShipInspectionsService) {
    }

    async activate() {
        const params = window.location.pathname.split("/").filter(x => x != null && x != "");
        if(params.length > 1)
        {
            this.guid = params[1];
        }

        if(params.length > 2)
        {
            this.response = Boolean(params[2]);
        }

        await this.checkAlreadySubmitted();

        if(!this.isAleardySubmitted && this.response == true)
        {
            await this.submit(true);
        }
    }

    attached() {
        document.addEventListener("click", this.documentClick);
    }

    detached() {
        document.removeEventListener("click", this.documentClick);
    }

    public documentClick: EventListenerOrEventListenerObject = e => {
        if (!(<any>e).propagationStopped) {
            this.eventAggregator.publish(Messages.documentClick, { source: "document" });
        }
    };

    async checkAlreadySubmitted()
    {
        if(this.guid)
        {
            this.model = await this.rightshipInsepctionsService.checkAlreadySubmittedRSInspectionCompanyResponse(this.guid);
            this.isAleardySubmitted = this.model != null && (<any>this.model) != "" && this.model.inspectionCompanyResponse != null;
        }
    }

    async submit(response: boolean) {
        this.response = response;
        const result = await this.rightshipInsepctionsService.submitRSInspectionCompanyResponse({ 
            guid: this.guid,
            response: this.response,
            rejectedReason: this.rejectedReason? this.rejectedReason.value: null,
            furtherInformation: this.furtherInformation
        });

        this.isAleardySubmitted = result.alreadySubmitted;
        this.model = result.inspection;
        this.isSuccessful = result.isSuccessful;
        this.errorMessage = result.message;
        this.isSubmit = true;
    }
}

export class RejectReasonModel
{
    id: number;
    value: string;
    displayText: string;
    hasFurtherInfo: boolean;
}
